import PropTypes from 'prop-types';
import React from 'react';
import { Flex, Position } from '@marvelapp/ui';
export default function ButtonWrap(_a) {
    var children = _a.children, isTextArea = _a.isTextArea;
    return (React.createElement(Position, { bottom: -35, left: isTextArea ? -10 : 0, position: "absolute", right: isTextArea ? -10 : 0 },
        React.createElement(Flex, { justifyContent: isTextArea ? 'space-between' : 'flex-end', py: 1 }, children)));
}
ButtonWrap.propTypes = {
    children: PropTypes.any,
};
